module.exports = __webpack_public_path__ + "img/ground-river-night.c37edc1c.png";